import React from 'react';
import ModuleReservation from '../components/ModuleReservation';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-[#0f172a] to-[#1e293b] text-white py-20 px-4 border-b-4 border-[#e2b13c] overflow-hidden">
        {/* Image de fond */}
        <div 
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage: 'url(/images/flotte-3-vehicules.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        
        {/* Contenu par-dessus */}
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-black mb-6 text-[#e2b13c] leading-tight drop-shadow-lg">
            VTC des Weppes : Votre Chauffeur Privé à Beaucamps-Ligny et Lille
          </h1>
          <h2 className="text-2xl font-semibold mb-8 text-gray-200 drop-shadow-md">
            L'humain avant l'algorithme : Ponctualité, confort et sérénité.
          </h2>
          <div className="text-lg leading-relaxed text-gray-300 max-w-3xl mx-auto bg-black bg-opacity-50 p-6 rounded-lg">
            <p className="mb-4">
              Oubliez le stress des compteurs et des embouteillages. Avec VTC des Weppes, votre tarif est fixe, transparent et garanti dès la réservation. Basé à Beaucamps-Ligny, nous venons vous chercher directement à votre porte pour vous conduire vers toutes vos destinations : aéroports, gares, hôtels ou événements privés.
            </p>
            <p className="font-semibold text-[#e2b13c]">
              Besoin d'aide pour réserver ? Contactez Catherine au 09 67 56 26 73.
            </p>
          </div>
        </div>
      </div>

      {/* Module de Réservation */}
      <div className="py-16 px-4">
        <ModuleReservation />
      </div>

      {/* Section Avantages */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-[#0f172a] p-8 rounded-lg border-2 border-[#e2b13c] text-center">
            <div className="text-5xl mb-4">💰</div>
            <h3 className="text-xl font-bold text-[#e2b13c] mb-3">Tarif Fixe Garanti</h3>
            <p className="text-gray-300">Pas de mauvaise surprise ! Le prix affiché est le prix final, sans frais cachés.</p>
          </div>
          <div className="bg-[#0f172a] p-8 rounded-lg border-2 border-[#e2b13c] text-center">
            <div className="text-5xl mb-4">⏰</div>
            <h3 className="text-xl font-bold text-[#e2b13c] mb-3">Ponctualité Garantie</h3>
            <p className="text-gray-300">Nous suivons votre vol ou train en temps réel pour vous accueillir à l'heure.</p>
          </div>
          <div className="bg-[#0f172a] p-8 rounded-lg border-2 border-[#e2b13c] text-center">
            <div className="text-5xl mb-4">👔</div>
            <h3 className="text-xl font-bold text-[#e2b13c] mb-3">Service Premium</h3>
            <p className="text-gray-300">Véhicules haut de gamme, chauffeurs professionnels et discrets.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;